import { useQuery } from '@tanstack/react-query';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../../contex/AuthProvider';
import Loading from '../../../Home/Share/Loading/Loading';
import toast from 'react-hot-toast';

const AllBuyer = () => {
    const { user } = useContext(AuthContext);

    const { data: orders = [], isLoading, refetch } = useQuery({
        queryKey: ['orders'],
        queryFn: async () => {
            const res = await fetch(`https://assignment-12-server-beige.vercel.app/usersType/u/buyer`, {
                headers: {
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                }
            });
            const data = await res.json();
            return data;
        }
    });
    if (isLoading) {
        return <Loading></Loading>
    }

    const handleDelete = (id) => {
        const proceed = window.confirm('Are you sure, you want to cancel this ');
        if (proceed) {
            fetch(`https://assignment-12-server-imraniium-su.vercel.app/users/${id}`, {
                method: 'DELETE',
                headers: {
                    authorization: `bearer ${localStorage.getItem('accessToken')}`
                }
            })
                .then(res => {
                    res.json()
                })
                .then(data => {
                    refetch()
                    toast.success('Successfully delete');
                    console.log(data);
                })
        }
    }

    return (
        <div>

            <h3 className='text-3xl font-semibold mb-5 text-center'>All Buyer</h3>


            <div className="overflow-x-auto m-3">
                <table className="table w-full">

                    <thead>
                        <tr>
                            <th></th>

                            <th>Name</th>
                            <th>Email</th>
                            <th>Verify</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            orders &&
                            orders?.map((book, i) => <tr key={book._id}>
                                <th>{i + 1}</th>
                                <td>{book.name}</td>
                                <td>{book.email}</td>
                                <td>
                                    <label>
                                        <button className='btn btn-primary btn-sm'>verify</button>
                                    </label>
                                </td>


                                <td>
                                    <label>
                                        <button onClick={() => handleDelete(book._id)} className='btn btn-primary btn-sm'>Delete</button>
                                    </label>

                                </td>


                            </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AllBuyer;
